import type {
  LngLat,
  Shape,
  ShapeOpening,
} from "../adapters/types";

/**
 * Le contour d'une forme, ses trous et ses ouvertures, qu'une transformation déplace ensemble. Les
 * ouvertures sont des positions le long des anneaux : seule une modification du nombre de sommets
 * les touche, elles sont donc facultatives ici.
 */
export interface ShapeRings {
  coordinates: LngLat[];
  holes: LngLat[][] | undefined;
  openings?: ShapeOpening[] | undefined;
}

export function ringsOf(shape: Shape): ShapeRings {
  return { coordinates: shape.coordinates, holes: shape.holes, openings: shape.openings };
}

/**
 * Remplace contour et trous, et les ouvertures quand `rings` en porte la clé. Un champ vide est
 * retiré plutôt que laissé à `undefined`.
 */
export function withRings(shape: Shape, rings: ShapeRings): Shape {
  const { holes: _holes, openings: _openings, ...rest } = shape;
  const openings = "openings" in rings ? rings.openings : shape.openings;

  return {
    ...rest,
    coordinates: rings.coordinates,
    ...(rings.holes?.length ? { holes: rings.holes } : {}),
    ...(openings?.length ? { openings } : {}),
  };
}

/** Applique la même transformation au contour et à chaque trou ; les ouvertures suivent sans changer. */
export function mapRings(shape: Shape, transform: (ring: LngLat[]) => LngLat[]): ShapeRings {
  return { coordinates: transform(shape.coordinates), holes: shape.holes?.map(transform), openings: shape.openings };
}
